import React from 'react';
import SvgIcon from '../../atoms/SvgIcon/SvgIcon';

var _ref = React.createElement(SvgIcon, {
  className: "page-menu__icon-box-icon page-menu__icon-delete",
  iconName: "ico_delete",
  color: "black"
});

var _ref2 = React.createElement("span", {
  className: "page-menu__icon-box-text"
}, "Lukk");

var _ref3 = React.createElement(SvgIcon, {
  className: "page-menu__icon-box-icon page-menu__icon-search",
  iconName: "ico_search",
  color: "black"
});

var _ref4 = React.createElement("span", {
  className: "page-menu__icon-box-text"
}, "S\xF8k");

const MenuTopPanel = ({
  isExpanded,
  onClickClose,
  onClickSearch,
  menuId,
  searchUrl
}) => React.createElement("div", {
  className: "page-menu__top-panel"
}, React.createElement("button", {
  "aria-label": "Lukk",
  className: "page-menu__close-button page-menu__icon-box",
  onClick: onClickClose,
  "aria-expanded": isExpanded,
  "aria-controls": menuId || 'page-header-menu'
}, _ref, _ref2), searchUrl ? React.createElement("a", {
  "aria-label": "S\xF8k",
  className: "page-menu__search-button page-menu__icon-box",
  onClick: onClickSearch,
  href: searchUrl
}, _ref3, _ref4) : null);

export default MenuTopPanel;